import { LoadingButton } from "@mui/lab";
import { Button, Grid, TextField, Typography } from "@mui/material";
import { useEffect, useRef } from "react";
import CustomModal from "../CustomModal/CustomModal";
import Show from "../Show/Show";
import styles from './RejectionReasonModal.module.scss';

interface RejectionReasoModalProps {
    onSubmit: (reason: string) => void
    isOpen: boolean
    close: () => void
    taskCount?: number
    loading?: boolean
    reason: string
    setReason: (reason: string) => void
}

export default function RejectionReasonModal(props: RejectionReasoModalProps) {

    const { onSubmit, isOpen, close, loading, reason, setReason, taskCount = 0 } = props
    const inputRef = useRef<HTMLInputElement>(null);


    useEffect(() => {
        if (isOpen) {
            const id = requestAnimationFrame(() => inputRef.current?.focus());
            return () => cancelAnimationFrame(id);
        }
    }, [isOpen]);

    return (

        <CustomModal title="Rejeitar Linhas de Trabalho" isActive={isOpen} handleClose={close}>
            <div>
                <form
                    onSubmit={(e) => {
                        e.preventDefault()
                        if (reason.trim()) {
                            onSubmit(reason)
                        }
                    }}
                >
                    <Typography variant="body1">
                        Indique o motivo da rejeição para informar a entidade executante. <br />
                    </Typography>

                    <div className={styles.RejectionReason}>

                        <TextField
                            autoFocus
                            label="Motivo da rejeição"
                            value={reason}
                            inputRef={inputRef}
                            onChange={(e) => setReason(e.target.value)}
                            fullWidth
                            required
                            multiline
                            minRows={3}
                        />

                    </div>

                    <div className={styles.RejectionDisclaimer}>
                        <Show on={taskCount > 1}>
                            <Typography variant="body2">
                                O motivo de rejeição vai ser aplicado às {taskCount} linhas de trabalho selecionadas.
                            </Typography>
                        </Show>
                    </div>

                    <Grid container justifyContent="flex-end" className={styles.RejectionActions}>
                        <Button onClick={() => close()} disabled={loading}>
                            Cancelar
                        </Button>
                        <LoadingButton
                            type="submit"
                            variant="contained"
                            color="error"
                            loading={loading}
                            disabled={!reason.trim()}
                        >
                            Rejeitar
                        </LoadingButton>

                    </Grid>
                </form>
            </div>
        </CustomModal >
    )
}
